<template>
  <div class="reserve">
    <div class="reserve-form">
      <van-search
        label="渠道"
        v-model="searchForm.channel_name"
        placeholder="请输入渠道名称"
        @input="debouncedHandleInput"
        show-action
      >
        <template #action>
          <div @click="getList">搜索</div>
        </template>
      </van-search>
      <!-- 选择面板，根据 showSuggestions 控制显示隐藏 -->
      <div
        v-if="showSuggestions"
        class="suggestion-panel"
      >
        <template v-if="columns.length === 0">
          <div style="text-align: center;margin-top: 30px;"><van-loading>数据加载中，请稍等...</van-loading></div>
        </template>
        <ul v-else>
          <!-- 遍历搜索建议列表，展示每个建议项 -->
          <li
            v-for="suggestion in columns"
            :key="suggestion.id"
            @click="selectSuggestion(suggestion)"
          >
            {{ suggestion.accountName }}
          </li>
        </ul>
      </div>
      <div class="date-label">
        <div
          class="label"
          v-for="(date, i) in dateList"
          :class="{'active': activeDateIndex === i}"
          :key="i"
          @click="changeDate(date, i)"
        >{{ date.label }}</div>
      </div>
      <van-form v-if="activeDateIndex === 0">
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="searchForm.dateString"
          right-icon="arrow"
          label="自定义日期"
          placeholder="点击选择最近时间"
          @click="dateShow = true"
        />
        <van-calendar
          v-model="dateShow"
          color="#e7635e"
          :min-date="new Date('2024-06-01')"
          :default-date="searchForm.date"
          :allow-same-day="true"
          @confirm="onDateConfirm"
          type="range"
        />
      </van-form>
    </div>
    <template v-if="isLoading">
      <div style="text-align: center;margin-top: 30px;"><van-loading>数据加载中，请稍等...</van-loading></div>
    </template>
    <template v-else>
      <van-collapse
        v-model="activeNames1"
        accordion
      >
        <van-collapse-item
          name="1"
          title="统计口径说明"
        >
          <el-row
            :gutter="8"
            class="data-list"
          >
            <el-col :span="6">
              <div class="bg">
                <div>加微人数</div>
                <div>{{ totalData.totalWChatNums }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="bg">
                <div>到店人数</div>
                <div>{{ totalData.totalPersonNum }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="bg">
                <div>到店人次</div>
                <div>{{ totalData.totalPersonTimes }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="bg">
                <div>消费金额</div>
                <div>{{ totalData.totalPaymentAmount }}</div>
              </div>
            </el-col>
          </el-row>
        </van-collapse-item>
      </van-collapse>
      <div class="reserve-list">
        <van-collapse
          v-model="activeNames"
          accordion
        >
          <van-collapse-item
            v-for="(item, i) in list"
            :key="i"
            :name="i"
            value-class="collapse-value"
            :class="{'bg-color-odd': i % 2 === 0, 'bg-color-even': i % 2 === 1}"
          >
            <template #title>
              <div>{{ item.channelName }}（{{ item.salesPersonName }}）</div>
              <div>消费金额：{{ item.everyPaymentAmount }}</div>
            </template>
            <template #value>
              <div>{{ item.dimDepartName }}</div>
              <div class="people">到店人次：{{ item.everyTimes }}</div>
            </template>
            <el-row>
              <el-col :span="12">
                <div>渠道家庭医生：<span style="color: #000;">{{ item.familyDoctor }}</span></div>
              </el-col>
              <el-col :span="12">
                <div>到店人数：<span style="color: #000;">{{ item.everyPersonCount }}</span></div>
              </el-col>
              <el-col :span="12">
                <div>渠道服务管家：<span style="color: #000;">{{ item.customerServiceManager }}</span></div>
              </el-col>
              <el-col :span="12">
                <div>加微人数：<span style="color: #000;">{{ item.everyWChatNums }}</span></div>
              </el-col>
              <el-col :span="12">
                <div>到店人次：<span style="color: #000;">{{ item.everyTimes }}</span></div>
              </el-col>
            </el-row>
          </van-collapse-item>
        </van-collapse>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import reportService from "@/apis/reserve/index.js";

export default {
  data() {
    return {
      activeNames1: "1",
      // 自定义时间
      dateShow: false,
      activeDateIndex: 1,
      dateList: [
        {
          label: "选择到店日期",
          date: [],
        },
        {
          label: moment().format("MM") + "月到店",
          date: [
            moment().startOf("month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
        {
          label: moment().subtract(1, "months").format("MM") + "月到店",
          date: [
            moment()
              .subtract(1, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
          ],
        },
        {
          label: moment().subtract(2, "months").format("MM") + "月到店",
          date: [
            moment()
              .subtract(2, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            moment().subtract(2, "months").endOf("month").format("YYYY-MM-DD"),
          ],
        },
        {
          label: moment().subtract(3, "months").format("MM") + "月到店",
          date: [
            moment()
              .subtract(3, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            moment().subtract(3, "months").endOf("month").format("YYYY-MM-DD"),
          ],
        },
      ],
      // 渠道
      columns: [],
      // 搜索条件
      searchForm: {
        channel_name: "",
        channel_manager: "",
        famil_doctor: "",
        customer_service_manager: "",
        dateString: "",
        date: [
          moment().startOf("month").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      },
      activeNames: undefined,
      isLoading: false, // 是否正在加载
      list: [],
      totalData: {},
      // 是否显示搜索建议面板
      showSuggestions: false,
    };
  },
  watch: {
    searchForm: {
      handler(newVal) {
        this.searchForm.dateString = `${moment(newVal.date[0]).format(
          "YYYY-MM-DD"
        )}至${moment(newVal.date[1]).format("YYYY-MM-DD")}`;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.debouncedHandleInput = this.debounce(this.handleInput, 500);
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 防抖函数
    debounce(func, delay) {
      let timer = null;
      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    handleInput() {
      if (this.searchForm.channel_name === "") {
        // 若搜索框为空，隐藏建议面板
        this.showSuggestions = false;
        return;
      }
      reportService
        .getChannelListApi({
          accountName: this.searchForm.channel_name,
        })
        .then((res) => {
          this.columns = res.data;
          // 若有匹配结果，显示建议面板
          this.showSuggestions = res.data.length > 0;
        });
    },
    selectSuggestion(suggestion) {
      // 用户选择某个建议后，将其填充到搜索框
      this.searchForm.channel_name = suggestion.accountName;
      // 隐藏建议面板
      this.showSuggestions = false;
    },
    changeDate(item, i) {
      this.activeDateIndex = i;
      if (i === 0) {
        this.searchForm.date = [];
      } else {
        this.searchForm.date = item.date;
      }
      this.getList();
    },
    onDateConfirm(date) {
      this.searchForm.date = date;
      this.dateShow = false;
      this.getList();
    },
    getList() {
      const { searchForm } = this;
      const params = {
        reservation_time_startTime: moment(searchForm.date[0]).format(
          "YYYY-MM-DD"
        ),
        reservation_time_endTime: moment(searchForm.date[1]).format(
          "YYYY-MM-DD"
        ),
        ...searchForm,
      };
      this.showSuggestions = false;

      this.isLoading = true;
      reportService
        .getChannelListItemApi(params)
        .then((res) => {
          this.totalData = res.data.totalData;
          this.list = res.data.listData;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getChannelList() {
      reportService
        .getChannelListApi({
          accountName: this.searchForm.channel_name,
        })
        .then((res) => {
          this.columns = res.data;
        });
    },
  },
};
</script>
<style lang="scss">
.collapse-value {
  .people {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.reserve-list {
  .van-cell {
    background: transparent;
  }
}
</style>
<style lang="scss" scoped>
.reserve {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .suggestion-panel {
    position: absolute;
    margin: 0 12px;
    top: 40px;
    left: 0;
    right: 0;
    background-color: #f7f8fa;
    z-index: 90;
    max-height: 300px;
    overflow-y: auto;
    ul,
    li {
      padding: 10px;
    }
  }
  .data-list {
    text-align: center;
    color: #fff;
    .bg {
      padding: 10px 0;
      background-color: #e7635e;
    }
  }
  .date-label {
    padding: 10px 0;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    .label {
      padding: 6px;
      border-radius: 20px;
      border: 1px solid #ccc;
      font-size: 14px;
      display: inline-block;
      margin-right: 10px;
    }
    .active {
      color: #e7635e;
      border-color: #e7635e;
    }
  }
  .total {
    margin: 10px 30px;
    font-size: 14px;
  }
  .el-button {
    width: 100%;
    background-color: #e7635e;
    border: none;
  }
  .reserve-title {
    margin-bottom: 10px;
    color: #e7635e;
    min-height: 40px;
  }
  .reserve-list {
    padding-bottom: 50px;
    overflow-y: auto;
  }
  .bg-color-odd {
    background-color: #F7F8FA;
  }
  .bg-color-even {
    background-color: #F2F2F2;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor.el-input__inner {
    width: 220px;
  }
}
</style>